import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelPropertySalesContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-sales/content'

export const ParcelPropertySalesWidget: FC = () => {
  return (
    <WidgetCard
      id="property-sales"
      title="Property Sales"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ParcelPropertySalesContent />,
        },
      ]}
    />
  )
}
